<template>
  <div>
    <div class="flex items-center mt-2">
      <div class="flex mx-auto cursor-pointer" @click="$router.push('/')">
        <img src="@/assets/images/logo/LogoFull.png" height="200" alt="Casa de la Biblia">
      </div>
    </div>
    <div class="vx-row" v-if="loaded">
      <vs-spacer/>
      <div class="vx-col w-full lg:w-1/2">
        <vx-card class="mt-base">
          <div class="w-full mt-2">
            <div class="text-center">
              <h6>Bienvenido, estamos validando su acceso, un momento por favor.</h6>
            </div>
          </div>
        </vx-card>
      </div>
      <vs-spacer/>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: "Access",
    methods: mapActions(['handleAuthentication']),
    data() {
      this.$auth.handleAuthentication();
      this.$router.push({name: 'home'});
      return {}
    }
  }
</script>

<style scoped>

</style>
